import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'client';

  private router = inject(Router);

  async ngOnInit() {
    await this.initNativeApp();
  }

  private async initNativeApp() {
    if (Capacitor.isNativePlatform()) {
      try {
        // 플랫폼별 클래스 추가 (CSS에서 safe-area 분기 처리용)
        const platform = Capacitor.getPlatform();
        document.documentElement.classList.add(`platform-${platform}`);
        document.body.classList.add(`platform-${platform}`);

        // 1. 먼저 스플래시 페이지로 이동 (네이티브 스플래시 위에 오버레이)
        await this.router.navigate(['/splash'], { replaceUrl: true });

        // 2. 네이티브 스플래시 숨김 (커스텀 스플래시가 보이는 상태)
        await SplashScreen.hide();

        // 3. 상태 바 설정 (원래대로 흰색 유지)
        await StatusBar.setOverlaysWebView({ overlay: false });
        await StatusBar.setBackgroundColor({ color: '#ffffff' });
        await StatusBar.setStyle({ style: Style.Default });
        await StatusBar.show();
      } catch (error) {
        console.error('Native initialization error:', error);
      }
    }
  }
}
